import { inject } from 'aurelia-framework';
import { DialogService } from 'aurelia-dialog';

var config = require('../../../config.js');

@inject(DialogService)
export class DialogHelperService {
    constructor(dialogService) {
        this.dialogService = dialogService;
    }

    macroPop(isV1) {
        var title = isV1 ? 'Macros' : 'Tokens';
        this.dialogService.open({
            viewModel: 'Advertiser.SharedPortal/lightbox/lightbox',
            model: {
                infoOnly: true,
                title: title,
                paragraphs: [
                    'You can embed the following ' +
                        title.toLowerCase() +
                        ' in your destination URLs:',
                    '{ad} - ad name',
                    '{address} - street address',
                    '{age} - applicant age',
                    '{campaign} - campaign name',
                    '{city} - contact city',
                    '{currently_insured} - currently insured',
                    '{date_of_birth} - date of birth',
                    '{device} - device type',
                    '{first_name} - first name',
                    '{homeowner} - homeowner',
                    '{last_name} - last name',
                    '{number_of_drivers} - number of drivers',
                    '{position} - ad position',
                    '{publisher} - publisher name',
                    '{source} - source name',
                    '{state_code} - 2 letter state code',
                    '{zip} - 5 digit code',
                    'For a complete explanation of ' +
                        title.toLowerCase() +
                        ' go to the ' +
                        title +
                        ' Reference page by clicking on the link below:'
                ],
                links: [
                    {
                        href: '#/' + title.toLowerCase(),
                        title: title,
                        text: title + ' Reference',
                        showRef: false
                    }
                ]
            }
        });
    }

    confirmChanges(viewModel, title, paragraphs, button1, button2) {
        var config = {
            viewModel: viewModel,
            model: {
                title: title,
                paragraphs: paragraphs
            }
        };

        if (button1) {
            config.model.button1 = button1;
        }
        if (button2) {
            config.model.button2 = button2;
        }

        return this.dialogService.open(config);
    }

    httpError(statusCode, code, router) {
        var title = 'Oops!';
        var message = [];
        var button1 = 'Ok';
        var button2 = 'Cancel';
        var infoOnly = true;
        var loginUrl = config.userPortalUrl + '/login';
        if (statusCode === 403 || code === 'sessionexpired') {
            router.navigate(loginUrl);
            return true;
        }

        switch (code) {
            case 'localfetch':
                title = 'System Error';
                // Because we don't return status codes in the local environment we have no idea what went wrong, except that the fetch call faild.
                message = [
                    'We are sorry for the inconvenience!',
                    'Error retrieving data from Delty. Please try logging in again.',
                    'If this fails to resolve the problem please contact the support team at Delty and report error: FetchError: ' +
                        statusCode
                ];
                button1 = 'Login';
                button2 = 'Cancel';
                infoOnly = false;
                break;
            case 'invalidurl':
                title = 'System Error - Invalid URL';
                message = [
                    'We are sorry for the inconvenience!',
                    'A system error was detected.  Please try refreshing the page.',
                    'If this fails to resolve the problem please try logging out and back in, or contact the support team at Delty and report error: InvalidURL: ' +
                        statusCode
                ];
                button1 = 'Cancel';
                infoOnly = true;
                break;
            case 'invalidurlaccessdenied':
                title = 'System error - invalid request (URL), access denied';
                message = [
                    'We are sorry for the inconvenience!',
                    'A system error was detected.  Please try refreshing the page.',
                    'If this fails to resolve the problem please contact the support team at Delty and report error: InvalidURLAccessDenied: ' +
                        statusCode
                ];
                button1 = 'Cancel';
                infoOnly = true;
                break;
            case 'notauthorizedtothisdata':
                title = 'Not authorized to this data';
                message = [
                    'We are sorry for the inconvenience!',
                    "It seems you're trying to access data that not authorized.  ",
                    'Please close your browser and try logging in again. If this fails to resolve the problem ',
                    'please contact the support team at Delty and report error: NotAuthorizedToThisData: ' +
                        statusCode
                ];
                button1 = 'Cancel';
                infoOnly = true;
                break;
            case 'internaldatacapacityerror':
                title = 'Temporary internal data capacity issue';
                message = [
                    'We are sorry for the inconvenience!',
                    'Our system has encountered a temporary data capacity issue. ',
                    'Please wait a few minutes and try again, but if the problem does not clear itself ',
                    'please contact the support team at Delty and report error: InternalDataCapacityIssue: ' +
                        statusCode
                ];
                button1 = 'Cancel';
                infoOnly = true;
                break;
            case 'undefined':
                title = 'System Error - undefined';
                message = [
                    'We are sorry for the inconvenience!',
                    'A system error was detected.  Please try refreshing the page.',
                    'If this fails to resolve the problem please contact the support team at Delty and report error: UndefinedError: ' +
                        statusCode
                ];
                button1 = 'Cancel';
                infoOnly = true;
                break;
        }

        return this.dialogService
            .open({
                viewModel: 'Advertiser.SharedPortal/lightbox/lightbox',
                model: {
                    title: title,
                    paragraphs: message,
                    button1: button1,
                    button2: button2,
                    infoOnly: infoOnly
                }
            })
            .whenClosed()
            .then(response => {
                if (button1 == 'Login' && !response.wasCancelled) {
                    router.navigate(loginUrl);
                } else {
                    return response;
                }
            });
    }
}
